import { Column, Order } from './table';

export function sortRows<Data>(
  rows: Data[],
  columns: readonly Column<Data>[],
  orderBy: keyof Data | undefined,
  order: Order | undefined,
): Data[] {
  if (!orderBy || !order) {
    return rows;
  }

  const column = columns.find((c) => c.id === orderBy);
  const getValue = (row: Data) => (column?.sortValue ? column.sortValue(row) : row[orderBy]);
  const direction = order === 'asc' ? 1 : -1;

  return [...rows].sort((a, b) => {
    const aVal = getValue(a);
    const bVal = getValue(b);
    if (aVal == null || aVal === '') return bVal == null || bVal === '' ? 0 : 1;
    if (bVal == null || bVal === '') return -1;
    if (typeof aVal === 'number' && typeof bVal === 'number') {
      return (aVal - bVal) * direction;
    }
    return (
      String(aVal).localeCompare(String(bVal), undefined, { numeric: true, sensitivity: 'base' }) *
      direction
    );
  });
}
